export default __webpack_public_path__ + "static/media/gradientStar.e026597f.svg";